// Map.js
import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, GeoJSON, } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { districtData } from "../data";
import DistrictDetails from "../District/District";
import "../Map/Map.css";


const Map = () => {
  const mapStyle = {
    height: "554px",
    width: "100%",
    backgroundColor:"#7595b1",
    border: "1px solid black",
    borderRadius: "19px",
    position: "relative",
    marginTop: "10px",  // Adjust the top margin as needed
    marginBottom: "10px",  // Adjust the bottom margin as needed  
  };

  const center = [33.6, 74.9];//j&k coordinates
  

  const getDistrictColor = (feature) => {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
  };


  const geoJSONStyle = {
    weight: 2, // Line weight
    opacity: 0.7, // Line opacity
    fillOpacity: 0.4, // Fill opacity
  };

  // Find the default district feature by its name, for example, 'Srinagar'
  const defaultDistrictFeature = districtData.features.find(
    (feature) => feature.properties.district === "Srinagar"
  );

  const [hoveredFeature, setHoveredFeature] = useState(null);
  const [selectedFeature, setSelectedFeature] = useState(
    defaultDistrictFeature
  );

  const handleDistrictClick = (feature) => {
    setSelectedFeature(feature);
  };

  const [weather, setWeather] = useState(null);



  useEffect(() => {
    // Fetch weather data when the selected district changes
    if (selectedFeature) {
      const apiKey = "c0b29958f988088a72cdf6fff07f99cc";
      const districtName = selectedFeature.properties.district;
      const apiUrl = `http://api.weatherstack.com/current?access_key=${apiKey}&query=${districtName}`;


      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          // Update the weather state with the retrieved data
          setWeather(data);
        })
        .catch((error) => {
          console.error("Error fetching weather data:", error);
        });
    }
  }, [selectedFeature]); // Trigger the effect when the selected district changes


  return (
    <div>
    <div className="backgroundImg">
      <div className="container-fluid ">
        <div className="container pt-5 pb-3 ">
      <h1 class="text-center pb-3">JAMMU AND KASHMIR-OVERVIEW</h1>
          <div className="row">
            <div className="col-lg-5 col-md-6 mb-4 card border p-5">
              <DistrictDetails
                districtData={districtData}
                selectedFeature={selectedFeature}
                weather={weather}
                onClose={() => setSelectedFeature(null)}
              />
            </div>
            <div className="col-lg-7 col-md-6 mb-4">
               

              <MapContainer
                center={center}
                zoom={8}
                style={{ ...mapStyle,  marginBottom: "0px",
                backgroundColor: "aquamarine"  }}
                // style={mapStyle}
                scrollWheelZoom={false}
                dragging={false}
                
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                 // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <GeoJSON
                  data={districtData}
                  // style={geoJSONStyle}
                  style={(feature) => ({
                   
                    color: feature === selectedFeature ? "brown" : "white", // Use green for the default district, red for others
                   
                    fillColor: feature === hoveredFeature ? "yellow" : getDistrictColor(feature),
                      fillOpacity: feature === selectedFeature ? 0.6 : 0, // Adjust the fill opacity
                      weight: 2,
                    ...geoJSONStyle,
                  })}
                  onEachFeature={(feature, layer) => {
                    layer.on({
                      mouseover: () => {
                        layer
                          .bindPopup(feature.properties.district)
                          .openPopup();
                        setHoveredFeature(feature);
                      },
                      mouseout: () => {
                        layer.closePopup();
                        setHoveredFeature(null);
                      },
                      click: () => handleDistrictClick(feature),
                    });
                  }}
                />
              </MapContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Map;
